/** The page numbers to show: first, last, the current one and its neighbours, with gaps marked 'gap'. */
export function pageWindow(current: number, total: number): (number | 'gap')[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
  const wanted = new Set([1, 2, total - 1, total, current - 1, current, current + 1])
  const sorted = [...wanted].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b)
  const out: (number | 'gap')[] = []
  for (const n of sorted) {
    const last = out[out.length - 1]
    if (typeof last === 'number' && n - last > 1) out.push('gap')
    out.push(n)
  }
  return out
}
